/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import { useAppSelector } from "@/redux/store";
import {
  selectActiveCall,
  selectActiveCallRoom,
  selectActiveCallToken,
} from "@/redux/slices/callsSlice";
import { selectUser } from "@/redux/slices/authSlice";
import { useCallManagement } from "@/lib/hooks/useCallManagement";
import { CallInterface } from "./CallInterface";

export default function ActiveCallDock() {
  const activeCall = useAppSelector(selectActiveCall);
  const room = useAppSelector(selectActiveCallRoom);
  const token = useAppSelector(selectActiveCallToken);
  const user = useAppSelector(selectUser);
  const { endCall } = useCallManagement();

  if (!activeCall || !room?.url || !token) {
    if (import.meta.env.DEV) {
      console.log("[ActiveCallDock] Returning null because:", {
        hasActiveCall: !!activeCall,
        hasRoomUrl: !!room?.url,
        hasToken: !!token,
        activeCallId: activeCall?.id,
      });
    }
    return null;
  }

  if (import.meta.env.DEV) {
    console.log("[ActiveCallDock] Rendering CallInterface for:", {
      roomId: room.url,
      tokenId: token ? token.substring(0, 10) : "none",
    });
  }

  const handleLeave = async () => {
    if (activeCall) {
      await endCall(activeCall.id);
    }
  };

  const handleMinimize = () => {
    // dispatch(setActiveCall(null));
    console.log("Minimizing call");
  };

  // Get visitor name from call data or use default
  const visitorName =
    activeCall.visitor?.metadata?.name || `Visitor ${activeCall.visitor_id.slice(0, 8)}`;

  return (
    <CallInterface
      roomUrl={room.url}
      token={token}
      userName={user?.name || "Sales Rep"}
      userId={user?.id || ""}
      callType={activeCall.call_type}
      visitorName={visitorName}
      visitorAvatar={activeCall.visitor?.metadata?.avatarUrl}
      onLeave={handleLeave}
      onMinimize={handleMinimize}
    />
  );
}
